import {Component, Input, OnDestroy, OnInit, inject} from '@angular/core';
import {Subscription} from 'rxjs';
import {Script, Patient, FilesRepositoryService} from '@xmedical/core';
import {PatientScriptsStore} from 'src/app/core/state/patient-scripts.store';
import {PatientStore} from 'src/app/core/state';

@Component({
    selector: 'app-script-widget',
    templateUrl: './script-widget.component.html',
    styleUrls: ['./script-widget.component.scss'],
    standalone: false
})
export class ScriptWidgetComponent implements OnInit, OnDestroy {

  @Input() script: Script;
  printing = false;
  private filesRepositorySubscription: Subscription;

  private scriptsStore = inject(PatientScriptsStore);
  private patientStore = inject(PatientStore);

  constructor(
    private filesRepository: FilesRepositoryService
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy() {
    if (this.filesRepositorySubscription) { this.filesRepositorySubscription.unsubscribe(); }
  }


  get patientId(): number {
    return this.patientStore.current()!.id;
  }

  get patient(): Patient {
    return this.patientStore.current()!;
  }

  get confirmationMessage(): string {
    return 'Are you sure you wish to print this script?';
  }

  print(id: number) {
    this.printing = true;
    this.filesRepositorySubscription = this.filesRepository.getUrl('script', id, this.patientId).subscribe(
      url => {
        window.open(url, '_blank');
        this.printing = false;
        this.scriptsStore.reload();
      }, error => {
        console.error(error);
        this.printing = false;
      });
  }
}
